module.exports = __webpack_public_path__ + "static/media/GT.e2a8f7ec.svg";